import { call, put, takeLatest, select } from 'redux-saga/effects';
import { captureException } from '../../../client/sentry';
import { graphql } from '../../../globals/api/requests';

import actions, {
  ADD_ITEM_TO_MY_PRODUCTS_REQUEST,
  IMPORT_LIST_TO_MY_PRODUCTS,
} from '../actions/lists';
import { setMobileSidebarView } from '../components/sidebar-mobile/actions';
import { promptToast } from '../../../components/toast-container/actions';
import mobileMenuActions from '../../navigation/actions/mobile-menu';

import { VIEWS } from '../components/sidebar-mobile/constants';
import { NO_MY_PRODUCTS_CREATED_ID, SIDEBAR_STATE } from '../constants';

import MyProductsMutation from '../my-products-mutation.graphql';
import MyProductsImport from '../my-products-import.graphql';

import {
  myProductsItemAdded,
  myProductsImported,
} from '../tracking/my-products';

export function* addItemToMyProducts({ product, isDesktop }) {
  const { tab } = yield select(state => state.areas.sidebar);

  if (!isDesktop) {
    yield put(mobileMenuActions.openMenu());
    yield put(setMobileSidebarView(VIEWS.LIST));
  }

  if (tab !== SIDEBAR_STATE.LISTS) {
    yield put(actions.openLists());
  }

  try {
    const response = yield call(graphql, MyProductsMutation, {
      productIds: [product.id],
    });

    if (response.errors) {
      yield put(actions.addListItemError(response.errors[0]));
    }

    if (response.data) {
      yield put(actions.selectList(response.data.myProductsItemsAdd.id));
      yield put(actions.addListItemSuccess());

      yield call(myProductsItemAdded, product.id);

      yield put(
        promptToast(
          'success',
          window.APP_GLOBALS.t('lists', 'confirm.item-added', {
            productName: product.name,
            listName: window.APP_GLOBALS.t('lists', 'my-products.title'),
          })
        )
      );
    }
  } catch (err) {
    yield call(captureException, err);
    yield put(actions.addListItemError(err));
  }
}

export function* importListToMyProducts({ listId }) {
  try {
    const response = yield graphql(MyProductsImport, {
      listId,
    });

    if (response.errors) {
      yield put(actions.addListItemError(response.errors[0]));
    }

    if (response.data) {
      const selectedList = yield select(
        state => state.areas.sidebar.selectedList
      );

      yield put(actions.importListToMyProductsSuccess());
      yield call(myProductsImported);

      if (selectedList === NO_MY_PRODUCTS_CREATED_ID) {
        yield put(actions.selectList(response.data.myProductsImport.id));
      }
    }
  } catch (err) {
    yield call(captureException, err);
    yield put(actions.addListItemError(err));
  }
}

function* myProductsSaga() {
  yield takeLatest(ADD_ITEM_TO_MY_PRODUCTS_REQUEST, addItemToMyProducts);
  yield takeLatest(IMPORT_LIST_TO_MY_PRODUCTS, importListToMyProducts);
}

export default myProductsSaga;
